import { z } from 'zod';
import superjson from 'superjson';

export const schema = z.object({
  sessionId: z.string().min(1),
  files: z.array(
    z.object({
      path: z.string(),
      action: z.enum(['create', 'update', 'delete']),
      content: z.string().optional(),
    }),
  ),
});

export type InputType = z.infer<typeof schema>;

export type OutputType = {
  message: string;
  error?: string;
};

export const generateCommitMessage = async (
  input: InputType,
  init?: RequestInit,
): Promise<OutputType> => {
  const result = await fetch('/_api/github/generate-commit-message', {
    method: 'POST',
    credentials: 'include',
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...(init?.headers ?? {}),
    },
    body: superjson.stringify(input),
  });

  if (!result.ok) {
    const errorObject = superjson.parse<{ error: string }>(await result.text());
    throw new Error(errorObject.error);
  }
  return superjson.parse<OutputType>(await result.text());
};
